var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-item" },
    [
      _c(
        "el-form-item",
        { attrs: { label: "列配置项" } },
        [
          _vm._l(_vm.columns, function(item, index) {
            return _c(
              "div",
              { key: index, staticClass: "setting-column_span" },
              [
                _c("el-input", {
                  staticClass: "column-span_value",
                  attrs: {
                    placeholder: "请输入栅格占据的列数",
                    type: "number"
                  },
                  model: {
                    value: _vm.formMap[item.id].baseOption.span,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.formMap[item.id].baseOption,
                        "span",
                        _vm._n($$v)
                      )
                    },
                    expression: "formMap[item.id].baseOption.span"
                  }
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass: "option-delete_button el-icon-minus",
                  on: {
                    click: function($event) {
                      return _vm.deleteColumn(item)
                    }
                  }
                })
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "text" }, on: { click: _vm.addColumn } },
            [_vm._v("添加列")]
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40f97d75", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40f97d75","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/base_setting/SettingGridColumns.vue
// module id = null
// module chunks = 